import React, {Component, Fragment} from 'react';
import WeaponListContent from './WeaponListContent';
import StatsContent from './stats/StatsContent';
import AppearanceContent from './AppearanceContent';
import AffixContent from './affixes/AffixContent';
import ItemSetContent from './itemsets/ItemSetContent';

export default class EquipmentContent extends Component {
    render() {
        const {equipment} = this.props;

        if(!equipment) {
            return null;
        }

        return (
            <Fragment>
                <AppearanceContent appearance={equipment.Appearance} />
                <AffixContent affix={equipment.Prefix} />
                <AffixContent affix={equipment.Suffix} />
                <ItemSetContent itemSet={equipment.ItemSet} />
                <WeaponListContent equipment={equipment} />
                <StatsContent stats={equipment.Stats} iLevel={equipment.iLevel} />
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/EquipmentContent.jsx